import { Avatar, Card, Dialog, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Typography } from '@mui/material'
import HeaderGestorConfigs from '../../../../utils/headerGestorConfigs'
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import api from '../../../../services/api'
import AddAnalistaRevisor from './addAnalistaRevisor'
import AnalisePh from './analises/analisePh'
import AnaliseDissolucao from './analises/analiseDissolucao'
import AnaliseInspeccaoVisualFisica from './analises/analiseInspeccaoVisualFisica'
import AnaliseCromatografia from './analises/analiseCromatografia'
import CheckBoxIcon from '@mui/icons-material/CheckBox';


export default function AvaliacaoAnalitica({ produto, refresh, setRefresh, solicitacaoAnalise, avaliacaoAnalitica, setAvaliacaoAnalitica }) {
  // const navegate = useNavigate()
  const { produtoId } = useParams()
  const { id } = useParams()
  const [modal, setModal] = useState(false);

  const handleClose = () => { setModal(false); }

  useEffect(() => {
    api.get(`/avalicao-analiticas?productoId=${produtoId}`)
      .then(response => {
        // console.log(response);
        setAvaliacaoAnalitica(response.data.avaliacaoAnaliticas[0]);
      }).catch(err => {
        // console.log(err)
      })
  }, [produtoId, refresh, modal])

  return (
    <>
      {avaliacaoAnalitica &&
        <>

          <Card style={{ padding: 15, marginTop: 20 }}>
            <HeaderGestorConfigs title={'Avalição Analitica'} />

            <List sx={{ width: '100%' }}>
              <ListItem >
                <ListItemAvatar>
                  {/* data.avaliacaoAnaliticas[0].revisor.dadosPessoais.nome */}
                  <Avatar src={avaliacaoAnalitica?.analista?.dadosPessoais?.fotoURL} style={{ marginRight: 5 }} />
                </ListItemAvatar>
                <ListItemText primary={avaliacaoAnalitica?.analista?.dadosPessoais?.nome} secondary={'Analista'} />
              </ListItem>

              <ListItem >
                <ListItemAvatar>
                  <Avatar src={avaliacaoAnalitica?.revisor?.dadosPessoais?.fotoURL} style={{ marginRight: 5 }} />
                </ListItemAvatar>
                <ListItemText primary={avaliacaoAnalitica?.analista?.dadosPessoais?.nome} secondary={'Revisor'} />
              </ListItem>

            </List>

            <Typography m><b>Tipos de análises solicitado:</b></Typography>

            {solicitacaoAnalise?.resultado !== "Aprovado" &&
              <List component="div">

                {/* case 'Análise de Desintegração':
                  return (
                    <ListItemButton key={index} onClick={() => navegate("/e")}>
                      Análise de Desintegração
                    </ListItemButton>
                  ); */}

                {produto.tipoAnalise.map((tipoAnalise, index) => {
                  switch (tipoAnalise) {
                    case 'Análise de Inspecção Física e Visual':
                      return (
                        <ListItemButton onClick={() => setModal('Análise de Inspecção Física e visual')} >
                          {/* <ListItemButton onClick={() => navegate(`/admin/dcqmts/gest/solicitacao-de-analise/analise-fisica-e-visual/${produtoId}/${avaliacaoAnalitica._id}/${id}`)} > */}
                          Análise de Inspecção Física e visual
                          {avaliacaoAnalitica?.inspeccaoVisualFisica?.resultado && <CheckBoxIcon color='secondary' />}
                        </ListItemButton>
                      );
                    case 'Análise de Cromatografia em Camada Fina':
                      return (
                        <ListItemButton onClick={() => setModal('Análise de Cromatografia em Camada Fina')} >
                          {/* <ListItemButton onClick={() => navegate(`/admin/dcqmts/gest/solicitacao-de-analise/analise-de-cromatografia/${produtoId}/${avaliacaoAnalitica._id}/${id}`)}> */}
                          Análise de Cromatografia em Camada Fina
                          {avaliacaoAnalitica?.cromatografia?.resultado && <CheckBoxIcon color='secondary' />}
                        </ListItemButton>
                      );
                    case 'Análise de PH':
                      return (
                        <ListItemButton onClick={() => setModal('Análise de PH')} >
                          {/* <ListItemButton onClick={() => navegate(`/admin/dcqmts/gest/solicitacao-de-analise/analise-de-ph/${produtoId}/${avaliacaoAnalitica._id}/${id}`)}> */}
                          Análise de PH
                          {avaliacaoAnalitica?.testesPH?.length > 0 && <><CheckBoxIcon color='secondary' /> {avaliacaoAnalitica?.testesPH?.length} </>}
                        </ListItemButton>
                      );
                    case 'Análise de Dissolução':
                      return (
                        <ListItemButton onClick={() => setModal('Análise de Dissolução')} >
                          {/* <ListItemButton onClick={() => navegate(`/admin/dcqmts/gest/solicitacao-de-analise/analise-de-dissolucao/${produtoId}/${avaliacaoAnalitica._id}/${id}`)}> */}
                          Análise de Dissolução
                          {avaliacaoAnalitica?.testesDissolucao?.length > 0 && <><CheckBoxIcon color='secondary' /> {avaliacaoAnalitica?.testesDissolucao?.length} </>}
                        </ListItemButton>
                      );
                    default:
                      return null;
                  }
                })}
              </List>
            }
          </Card>


          {/* ABRIR MODAL DE FORMULARIOS DE ANALISES */}
          <Dialog
            maxWidth={'md'}
            open={!!modal}
            // TransitionComponent={Transition}
            // keepMounted
            // onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"
          >
            {/* <DialogTitle>{modal?.nome}</DialogTitle> */}

            {modal === 'Análise de Inspecção Física e visual' &&
              <AnaliseInspeccaoVisualFisica avaliacaoId={avaliacaoAnalitica?._id} ficha={false} handleClose={handleClose} />
            }
            {modal === 'Análise de Cromatografia em Camada Fina' &&
              <AnaliseCromatografia avaliacaoId={avaliacaoAnalitica?._id} ficha={false} handleClose={handleClose} />
            }
            {modal === 'Análise de PH' &&
              <AnalisePh avaliacaoId={avaliacaoAnalitica?._id} ficha={false} handleClose={handleClose} />
            }
            {modal === 'Análise de Dissolução' &&
              <AnaliseDissolucao avaliacaoId={avaliacaoAnalitica?._id} ficha={false} handleClose={handleClose} />
            }
          </Dialog>
        </>
      }



      {solicitacaoAnalise?.status === "Autorização para Análise Laboratorial" &&
        <AddAnalistaRevisor
          solicitacaoAnaliseId={id}
          productoId={produtoId}
          setRefresh={setRefresh}
        />
      }

      {avaliacaoAnalitica?.inspeccaoVisualFisica?.resultado &&
        <AnaliseInspeccaoVisualFisica ficha={true} analises={avaliacaoAnalitica?.inspeccaoVisualFisica} />
      }

      {avaliacaoAnalitica?.cromatografia?.resultado &&
        <AnaliseCromatografia ficha={true} analises={avaliacaoAnalitica?.cromatografia} />
      }

      {avaliacaoAnalitica?.testesPH?.length > 0 &&
        <AnalisePh ficha={true} analises={avaliacaoAnalitica?.testesPH} />
      }

      {avaliacaoAnalitica?.testesDissolucao?.length > 0 &&
        <AnaliseDissolucao ficha={true} analises={avaliacaoAnalitica?.testesDissolucao} />
      }
    </>
  )
}